import { Dispatch, Action } from 'redux'
import { ProCanceledMainMapDispatchReturnType } from './types/ProCanceledMainMapDispatchReturnType'

export const ProCanceledMainMapDispatch = (
  _dispatch: Dispatch<Action>
): ProCanceledMainMapDispatchReturnType => {
  return {
  }
}
